// extracted by mini-css-extract-plugin
export var button = "_mo-0";
export var donut = "_mo-1";
export var donutFill = "_mo-3";
export var donutTrack = "_mo-2";